import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'date-format-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="cell-text">{{ data | date : 'dd MMM yyyy' }}</span>
  `,
  styles: [
    `
      .cell-text {
        font-family: var(--manrope);
        font-weight: 500;
        font-size: 16px;
        color: var(--text-secondary);
      }
    `,
  ],
})
export class DateFormatCellComponent {
  @Input() data: any;
}
